import slug from 'slug';
import { nanoid } from 'nanoid';
import copy from 'copy-to-clipboard';

export function capitalizeFirstLetter(string) {
	return string ? string.charAt(0).toUpperCase() + string.slice(1) : '';
}

export function slugify(string) {
	return string ? slug(string) : '';
}

export function copyToClipboard(text) {
	return copy(text);
}

export function textToColor(str) {
	str = `${str}`;
	let hash = 0;
	for(let i = 0; i < str.length; i++) {
		hash = str.charCodeAt(i) + ((hash << 5) - hash);
	}
	let color = '#';
	for(let i = 0; i < 3; i++) {
		const value = (hash >> (i * 8)) & 0xFF;
		color += (`00${value.toString(16)}`).substr(-2);
	}
	return color;
}

export function hex2rgb(hex) {
	const r = parseInt(hex.slice(1, 3), 16);
	const g = parseInt(hex.slice(3, 5), 16);
	const b = parseInt(hex.slice(5, 7), 16);

	// return {r, g, b}
	return { r, g, b };
}

// from: https://gist.github.com/kongchen/941a652882d89bb96f87
export function utf8To16(input) {
	const _escape = s => {
		function q(c) {
			const e = c.charCodeAt();
			return `%${(e < 16 ? '0' : '')}${e.toString(16).toUpperCase()}`;
		}
		return s.replace(/[\x00-),:-?[-^`{-\xFF]/g, q);
	};
	try {
		return decodeURIComponent(_escape(input));
	} catch (URIError) {
		// include invalid character, cannot convert
		return input;
	}
}

export function nl2br(str, isXhtml) {
	if(typeof str === 'undefined' || str === null) {
		return '';
	}
	const breakTag = (isXhtml || typeof isXhtml === 'undefined') ? '<br />' : '<br>';
	return `${str}`.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, `$1${breakTag}$2`);
}

export function splitCamelCase(s) {
	return `${s}`.split(/([A-Z][a-z]+)/).filter(e => e);
}

export function stripTags(s, options = { removeSpecialChars: true, removeSpaces: true }) {
	const tagRegExp = new RegExp(/(<([^>]+)>)/, 'gi');
	const specialCharsRegExp = new RegExp(/&[a-z]*;/, 'gi');
	const spaceRegExp = new RegExp(/\s/, 'gi');
	let string = (s || '').replace(tagRegExp, '');
	if(options.removeSpecialChars) {
		string = string.replace(specialCharsRegExp, '');
	}
	if(options.removeSpaces) {
		string = string.replace(spaceRegExp, '');
	}
	return string;
}

// Split a delimited string (eg: CSV cell "a | b") into items cleared of surrounding spaces, tabs and line breaks
export function splitList(str, separator = '|', keepEmpty = false) {
	const items = str ? `${str}`.split(separator).map(item => item.trim()) : [];
	return keepEmpty ? items : items.filter(item => item);
}

export function truncate(str, count = 20, splitType = 'word') {
	return splitType === 'word' ? (str || '').split(' ').splice(0, count).join(' ') : (str || '').slice(0, count);
}

export function escapeRegExp(str) {
	return `${str || ''}`.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}

export function getRandomString(size = 10, onlyNumbers = false) {
	if(onlyNumbers) {
		let s = '';
		for(let i = 0; i < size; i += 1) {
			s += Math.floor(Math.random() * 10);
		}
		return s;
	}
	// polyfills.js
	if(typeof window !== 'undefined' && !window.crypto) {
		window.crypto = window.msCrypto;
	}

	return nanoid(size);
}
